import { render, staticRenderFns } from "./SelectorDialog.vue?vue&type=template&id=3afdcb64&"
import script from "./SelectorDialog.vue?vue&type=script&lang=js&"
export * from "./SelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports